import {
	styledSystem as ss,
	buttonStyles,
	buttonSizes,
	buttonVariants,
} from ".";

export type IButtonProps = ss.ICommonProps &
	{
		block?: boolean;
		clean?: boolean;
		s?: "sm" | "lg" | "font";
		variant?: "primary" | "danger" | "outline" | "link";

		// To support links
		to?: string;
		href?: string;
		target?: string;
	}
;

// Basic button
export const Button = ss.styled.button<IButtonProps>`
	${buttonStyles}
	${props => props.s && buttonSizes[props.s] ? buttonSizes[props.s] : undefined}
	${props => props.block ? { width: "100%", display: "block", textAlign: "center" } : undefined }
	${props => props.variant && buttonVariants[props.variant] ? buttonVariants[props.variant] : undefined }
	${ss.COMMON}
	${props => props.clean ? { borderColor: "transparent", backgroundColor: "transparent", color: "inherit" } : undefined }
`;

// Variants
// @ts-ignore
export const ButtonPrimary = ss.styled(Button)``; ButtonPrimary.defaultProps = { variant: "primary" };
export const ButtonDanger = ss.styled(Button)``; ButtonDanger.defaultProps = { variant: "danger" };
export const ButtonOutline = ss.styled(Button)``; ButtonOutline.defaultProps = { variant: "outline" };
export const ButtonLink = ss.styled(Button)``; ButtonLink.defaultProps = { variant: "link" };
